/*
 * @Description:
 * @Version: 2.0
 * @Autor: shimnx
 * @Date: 2021-08-04 09:07:37
 * @LastEditors: Lan, Peng
 * @LastEditTime: 2023-06-08 15:55:25
 */
import { BrowserModule } from '@angular/platform-browser';
import { Injectable, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { MatDividerModule, MatToolbarModule, MatMenuModule, MatListModule } from '@angular/material';
import { AppRoutingModule } from '@/app/app-routing.module';
import { AppComponent } from '@/app/app.component';
import { PageNotFoundComponent } from '@/app/result/404/page-not-found.component';
import { NoPermissionComponent } from '@/app/result/401/no-permission.component';
import { HttpClientModule, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DatePipe, registerLocaleData } from '@angular/common';
import { selfHttp } from './http-units.service';
import { SimpleReuseStrategy } from './SimpleReuseStrategy';
// mat 官方组件库
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { apiList } from './app.api';
import { httpInterceptorProviders } from './http-intercepts/index';
import { MatSnackBar, MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { SnackbarComponent } from './pages/snackbar/snackbar.component';
import { ngfModule } from 'angular-file';
import { MatSelectModule } from '@angular/material/select';
import { MtxGridModule } from '@ng-matero/extensions/grid';
import { MatDatepickerModule } from '@angular/material/datepicker';
// import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
// import { MatDateFormats, MAT_DATE_FORMATS, NativeDateAdapter, DateAdapter } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { MatChipsModule } from '@angular/material/chips';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { HttpClient } from '@angular/common/http';
import { DemoButtonComponent } from './components/button/button.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { JwtModule } from '@auth0/angular-jwt';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenComponent } from './token/token.component';
import { Router, RouteReuseStrategy } from '@angular/router';
import { tap } from 'rxjs/operators';
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

import en from '@angular/common/locales/en';
import { ConfirmComponent } from './components/confirm/confirm.component';
// import { FileListComponent } from './components/file-list/file-list.component';
import { environment } from '@/environments/environment';
import { getUsedLang } from './utils';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CommonLoadingComponent } from './components/common-loading/common-loading.component';
import { LoadingServiceT } from './common-loading.service';
import { LoadingInterceptor } from './loading.interceptors';
import { ConfirmApproveComponent } from './components/confirm-approve/confirm-approve.component';
import { BatchApprovalSnackbarComponent } from './components/batch-approval-snackbar/batch-approval-snackbar.component';
import { LANG_TYPE } from './constant';
// import { ApprovalHistoryComponent } from './components/approval-history/approval-history.component';

// import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatPaginatorIntl } from '@angular/material/paginator';
// import { CustomPaginatorIntl } from './custom-paginator-intl.service';

export const DateFormat = {
  parse: {
    dateInput: 'input',
  },
  display: {
    dateInput: 'YYYY/MM/DD',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'YYYY/MM/DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// import { ContentDetailComponent } from './components/content-detail/content-detail.component';
registerLocaleData(en);
export class AddHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new headerAddHeaderInterceptor
    const clonedRequest = req.clone({
      // let token = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjUwMjk2NDZDQTdFRjY5MzVGOUI1MzIzMDc5MkM2NTVCIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2NzU4MjE4MzEsImV4cCI6MTY3NTg2NTAzMSwiaXNzIjoiaHR0cDovLzEwLjIzNS41MC4xNjk6NzA3NyIsImF1ZCI6IlNlcnZlciIsImNsaWVudF9pZCI6IlNjcnVtQm9hcmQiLCJzdWIiOiJlNmI5ZGNhYy1lNzVhLTQyMWYtODJhYy1lNzFiN2M3OTY0ZmMiLCJhdXRoX3RpbWUiOjE2NzU4MjE4MzAsImlkcCI6ImxvY2FsIiwidGVuYW50aWQiOiIzYTA0Nzk0NC00M2VlLTg2NTEtMTNjZC1lZTJjODlkY2E3ZmUiLCJyb2xlIjpbIkFkbWluaXN0cmF0b3JzIiwia2ltaSBhZG1pbiIsIkV4dGVybmFsIFJlc291cmNlIiwiRGVmYXVsdCJdLCJwaG9uZV9udW1iZXIiOiIxNTkyMTM1ODQ0NiIsImVtYWlsIjoibGFucG5nQHNjaGFlZmZsZXIuY29tIiwibmFtZSI6IjI4MDM2NzkxIiwiaWF0IjoxNjc1ODIxODMxLCJzY29wZSI6WyJhZGRyZXNzIiwiZW1haWwiLCJvcGVuaWQiLCJwaG9uZSIsInByb2ZpbGUiLCJyb2xlIiwiU2VydmVyIiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbInB3ZCJdfQ.oa-LhNF97kGikYxKHVIETLpXIAItMmReJ1ImyeQ1YNUfxGjd3LaOyZ_3mOAG818K6Ayyo6Si1brHgSO3PgTZAZZCZ3VtfoPHR6SAs9vQ2lEZbSjdnA0k_zVa2jYTV1sfdXO0UOPE-al_Y5Tg2GbT59befLsOYj7kgUslqG99lv8k9uPLfUoQgTy47IPFtzWMhGhPpXa0QPIVUjc-lA54mB1eac7qi7da_FjiGstqRrrR9x03cZqIN-x_eseXO3yOJLyHdbvv8pJ71TLRY3mNZsYCCqAtk5VE-TIOQoVoyvm41bbl8aPjiUrJ0oJzC310WE9GHCJApPiB11KRpjdegQ"
      // headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token')),
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        // 'Authorization': "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjUwMjk2NDZDQTdFRjY5MzVGOUI1MzIzMDc5MkM2NTVCIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2NzU4MjE4MzEsImV4cCI6MTY3NTg2NTAzMSwiaXNzIjoiaHR0cDovLzEwLjIzNS41MC4xNjk6NzA3NyIsImF1ZCI6IlNlcnZlciIsImNsaWVudF9pZCI6IlNjcnVtQm9hcmQiLCJzdWIiOiJlNmI5ZGNhYy1lNzVhLTQyMWYtODJhYy1lNzFiN2M3OTY0ZmMiLCJhdXRoX3RpbWUiOjE2NzU4MjE4MzAsImlkcCI6ImxvY2FsIiwidGVuYW50aWQiOiIzYTA0Nzk0NC00M2VlLTg2NTEtMTNjZC1lZTJjODlkY2E3ZmUiLCJyb2xlIjpbIkFkbWluaXN0cmF0b3JzIiwia2ltaSBhZG1pbiIsIkV4dGVybmFsIFJlc291cmNlIiwiRGVmYXVsdCJdLCJwaG9uZV9udW1iZXIiOiIxNTkyMTM1ODQ0NiIsImVtYWlsIjoibGFucG5nQHNjaGFlZmZsZXIuY29tIiwibmFtZSI6IjI4MDM2NzkxIiwiaWF0IjoxNjc1ODIxODMxLCJzY29wZSI6WyJhZGRyZXNzIiwiZW1haWwiLCJvcGVuaWQiLCJwaG9uZSIsInByb2ZpbGUiLCJyb2xlIiwiU2VydmVyIiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbInB3ZCJdfQ.oa-LhNF97kGikYxKHVIETLpXIAItMmReJ1ImyeQ1YNUfxGjd3LaOyZ_3mOAG818K6Ayyo6Si1brHgSO3PgTZAZZCZ3VtfoPHR6SAs9vQ2lEZbSjdnA0k_zVa2jYTV1sfdXO0UOPE-al_Y5Tg2GbT59befLsOYj7kgUslqG99lv8k9uPLfUoQgTy47IPFtzWMhGhPpXa0QPIVUjc-lA54mB1eac7qi7da_FjiGstqRrrR9x03cZqIN-x_eseXO3yOJLyHdbvv8pJ71TLRY3mNZsYCCqAtk5VE-TIOQoVoyvm41bbl8aPjiUrJ0oJzC310WE9GHCJApPiB11KRpjdegQ",
        requestId: localStorage.getItem('requestId'),
        'Accept-Language': getUsedLang(false, true),
      }),
    });
    return next.handle(clonedRequest);
  }
}
@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  constructor(public translate: TranslateService, private _snackBar: MatSnackBar) {}
  router: Router;
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // 对响应消息进行处理
    if (localStorage.getItem('token')) {
      let strings = localStorage.getItem('token').split('.'); //截取token，获取载体
      var userinfo = JSON.parse(decodeURIComponent(window.atob(strings[1].replace(/-/g, '+').replace(/_/g, '/'))));
      var timestamp = new Date().getTime();

      if (timestamp > userinfo.exp * 1000) {
        // localStorage.clear();
        // location.reload();
      }
    }
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.status >= 200 && event.status < 300) {
          }
        },
        (error) => {
          if (error.status == '402') {
            this.translate.use(localStorage.getItem('lang') || LANG_TYPE.EN);
            this.translate.get('common.tokenExpired').subscribe((msg: string) => {
              this._snackBar.openFromComponent(SnackbarComponent, {
                data: { message: msg, action: 'error' },
                verticalPosition: 'top',
                duration: 3000,
                panelClass: ['red-snackbar'],
              });
            });
            setTimeout(() => {
              localStorage.clear();
              window.location.href = environment.homeUrl + '/#/LoginType';
            }, 3000);
          } else if (error.status == '406') {
            window.location.href = environment.homeUrl + '/#/maintenance';
          } else {
            this._snackBar.openFromComponent(SnackbarComponent, {
              data: { message: error.error.Message || error.error.message, action: 'error' },
              verticalPosition: 'top',
              duration: 3000,
              panelClass: ['red-snackbar'],
            });
          }
          if (error.error.Message.indexOf('IDX10501') > -1 || error.error.Message.indexOf('IDX10223') > -1) {
            window.location.href = environment.homeUrl + '/#/LoginType';
          }
        }
      )
    );
  }
}
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    DemoButtonComponent,
    PageNotFoundComponent,
    NoPermissionComponent,
    SnackbarComponent,
    TokenComponent,
    ConfirmComponent,
    ConfirmDialogComponent,
    CommonLoadingComponent,
    ConfirmApproveComponent,
    BatchApprovalSnackbarComponent,
    // ApprovalHistoryComponent
    // FileListComponent,
    // ProjectActionEditorComponent,
    //   ContentDetailComponent,
    //   ViewActionComponent,
    //   ActionEditorComponent,
  ],
  imports: [
    MatTooltipModule,
    MtxPopoverModule,
    MatMenuModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatChipsModule,
    ngfModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MtxGridModule,
    MatButtonModule,
    MatSidenavModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatCheckboxModule,
    NzTableModule,
    NzToolTipModule,
    NzPopoverModule,
    NzCollapseModule,
    MatAutocompleteModule,
    // MatDividerModule,
    // MatToolbarModule,
    // MatMenuModule,
    // MatListModule,
    MatTableModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('token');
        },
      },
    }),
  ],
  providers: [
    apiList,
    DatePipe,
    LoadingServiceT,
    selfHttp,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: SimpleReuseStrategy },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
    { provide: MAT_DATE_FORMATS, useValue: DateFormat },
    // { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }
  ],
  entryComponents: [SnackbarComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
